import { render, staticRenderFns } from "./XYKSView.vue?vue&type=template&id=7af5953f&scoped=true&"
import script from "./XYKSView.vue?vue&type=script&lang=js&"
export * from "./XYKSView.vue?vue&type=script&lang=js&"
import style0 from "./XYKSView.vue?vue&type=style&index=0&id=7af5953f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af5953f",
  null
  
)

export default component.exports